// extracted by mini-css-extract-plugin
module.exports = {"v1qp8171":"v1qp8171","section-aside-container":"section-aside-container","c1duftle":"c1duftle"};